export const fiAuthenticationDict = {
  'Back to Sign In': 'Takaisin kirjautumiseen',
  'Change Password': 'Vaihda salasana',
  Code: 'Koodi',
  'Code *': 'Sähköpostiisi lähetetty koodi',
  'Confirm Password': 'Salasana uudelleen',
  'Create Account': 'Rekisteröidy',
  Email: 'Sähköposti',
  'Enter your Email': 'Kirjoita sähköpostiosoitteesi',
  'Enter your email': 'Kirjoita sähköpostiosoitteesi',
  'Enter your Password': 'Kirjoita haluamasi salasana',
  'Forgot your password?': 'Unohditko salasanasi?',
  'Invalid verification code provided, please try again.': 'Virheellinen koodi, yritä uudelleen.',
  'New password': 'Uusi salasana',
  'New Password': 'Uusi salasana',
  or: 'tai',
  Password: 'Salasana',
  'Please confirm your Password': 'Kirjoita haluamasi salasanasi uudelleen',
  'Resend Code': 'Lähetä uusi koodi sähköpostiin',
  'Reset Password': 'Vaihda salasana',
  'Send code': 'Lähetä koodi sähköpostiin',
  Sending: 'Lähetetään',
  'Sign In with Google': 'Kirjaudu Google-tilillä',
  'Sign in': 'Kirjaudu',
  'Sign In': 'Kirjaudu',
  'Sign Up with Google': 'Rekisteröidy Google-tilillä',
  'Signing in': 'Kirjaudutaan',
  Submit: 'Lähetä',
  Submitting: 'Lähetetään',
}
